import { Box } from '@rover/kibble/core';
import { TABLET_MAX, TABLET_MIN } from '@rover/kibble/styles/MediaQuery';

type Props = {
  results: JSX.Element[];
};

const MaximalSearchCardsGrid = ({ results }: Props): JSX.Element => {
  return (
    <Box
      width="100%"
      maxWidth="100%"
      display="grid"
      mt="4x"
      sx={{
        overflow: 'hidden',
        gridAutoFlow: 'dense', // backfill any cell left empty before a full-width callout
        gridTemplateColumns: 'minmax(0, 1fr)',
        [`@media (min-width: ${TABLET_MIN}px)`]: {
          gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)',
        },
        [`@media (min-width: ${TABLET_MAX + 1}px)`]: {
          gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
        },
      }}
    >
      {results}
    </Box>
  );
};

export default MaximalSearchCardsGrid;
